// @flow
export const barColourModes = {
    YDOMAIN: 'Y_DOMAIN',
    XINDEX: 'X_INDEX',
    SINGLE: 'SINGLE'
};

export const responsiveVars = {
    BAR_RADIUS_MEDIUM: 5,
    BAR_RADIUS_SMALL: 2,
    BAR_AMOUNT_LIMIT: 10,
    GRAPH_WIDTH_MEDIUM: 640,
    GRAPH_HEIGHT_COEF_MEDIUM: 0.5,
    GRAPH_HEIGHT_COEF_SMALL: 0.75,
    GRAPH_MAX_HEIGHT_COEF: 250,
    GUTTER_SPACING_L: 2,
    GUTTER_SPACING_S: 1
};

export const textAnchor = {
    END: 'end',
    MIDDLE: 'middle',
    START: 'start'
};



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/constants.js